import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const aireldConfig: TSPConfig = {
  key: 'aireld',
  name: 'Air ELD',
  imageName: 'AirELD',
  category: TSPCategory.API_KEY,
  helpText: 'Please enter your Air ELD API key to connect your account.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default aireldConfig;
